import { StoreState } from "..";

export const getUser = (state: StoreState) => state.auth.user;
export const getUserUid = (state: StoreState) => state.auth.user.uid;



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/auth/selectors.ts